export interface DeviceIntervalsState {
  activeIntervalId: ReturnType<typeof setInterval> | null
  activeIntervalType: string | null
  appUpdateCallback: (() => void) | null
  appInterval: number | null
}

export interface StartIntervalPayload {
  callback: () => void
  interval: number
}

export interface SetIntervalPayload {
  id: ReturnType<typeof setInterval>
  type: string
}

export enum IntervalType {
  APP = 'app',
  MANAGE_DEVICES = 'manageDevices'
}

export enum DEVICE_INTERVALS_MUTATIONS {
  SET_INTERVAL = 'setInterval',
  CLEAR_INTERVAL = 'clearInterval',
  SET_APP_UPDATE_CALLBACK = 'setAppUpdateCallback',
  SET_APP_INTERVAL = 'setAppInterval'
}

export enum DEVICE_INTERVALS_ACTIONS {
  START_APP_INTERVAL = 'startAppInterval',
  START_MANAGE_DEVICES_INTERVAL = 'startManageDevicesInterval',
  CLEAR_INTERVAL = 'clearInterval',
  RESTART_APP_INTERVAL = 'restartAppInterval'
}

export enum DEVICE_INTERVALS_GETTERS {
  IS_APP_INTERVAL_ACTIVE = 'isAppIntervalActive',
  IS_MANAGE_DEVICES_INTERVAL_ACTIVE = 'isManageDevicesIntervalActive'
}
